import React, { useEffect, useState } from 'react';

const StartPractice = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate random particles for animation
    const generateParticles = () => {
      const newParticles = [];
      for (let i = 0; i < 50; i++) {
        newParticles.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: Math.random() * 6 + 2,
          duration: Math.random() * 20 + 10,
          delay: Math.random() * 5
        });
      }
      setParticles(newParticles);
    };

    generateParticles();
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(-45deg, #667eea, #764ba2, #f093fb, #f5576c, #4facfe, #00f2fe)',
      backgroundSize: '400% 400%',
      animation: 'gradientShift 15s ease infinite'
    }}>
      <style jsx>{`
        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
            opacity: 0.7;
          }
          50% {
            transform: translateY(-20px) rotate(180deg);
            opacity: 1;
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        @keyframes sparkle {
          0%, 100% {
            opacity: 0;
            transform: scale(0);
          }
          50% {
            opacity: 1;
            transform: scale(1);
          }
        }

        .particle {
          position: absolute;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.6);
          pointer-events: none;
          animation: float var(--duration) ease-in-out infinite;
          animation-delay: var(--delay);
        }

        .geometric-shape {
          position: absolute;
          border-radius: 20% 80% 80% 20%;
          background: rgba(255, 255, 255, 0.1);
          animation: float 8s ease-in-out infinite;
        }

        .coming-soon-container {
          text-align: center;
          z-index: 10;
          position: relative;
          padding: 40px;
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.1);
          border-radius: 30px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.1);
          animation: slideInUp 1s ease-out, pulse 3s ease-in-out infinite;
        }

        .main-title {
          font-size: 3.5rem;
          font-weight: bold;
          color: white;
          margin-bottom: 20px;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
          animation: bounce 2s ease-in-out infinite;
        }

        .subtitle {
          font-size: 1.5rem;
          color: rgba(255, 255, 255, 0.9);
          margin-bottom: 30px;
          font-weight: 300;
          letter-spacing: 1px;
        }

        .message {
          font-size: 1.1rem;
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
          max-width: 500px;
          margin: 0 auto;
        }

        .sparkle {
          position: absolute;
          width: 4px;
          height: 4px;
          background: white;
          border-radius: 50%;
          animation: sparkle 2s ease-in-out infinite;
        }

        @media (max-width: 768px) {
          .main-title {
            font-size: 2.5rem;
          }
          .subtitle {
            font-size: 1.2rem;
          }
          .message {
            font-size: 1rem;
          }
          .coming-soon-container {
            padding: 30px 20px;
            margin: 20px;
          }
        }

        @media (max-width: 480px) {
          .main-title {
            font-size: 2rem;
          }
          .subtitle {
            font-size: 1rem;
          }
          .message {
            font-size: 0.9rem;
          }
        }
      `}</style>

      {/* Animated Particles */}
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="particle"
          style={{
            left: `${particle.x}%`,
            top: `${particle.y}%`,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            '--duration': `${particle.duration}s`,
            '--delay': `${particle.delay}s`
          }}
        />
      ))}

      {/* Geometric Shapes */}
      <div 
        className="geometric-shape"
        style={{
          top: '10%',
          left: '10%',
          width: '100px',
          height: '100px',
          animationDelay: '0s'
        }}
      />
      <div 
        className="geometric-shape"
        style={{
          top: '70%',
          right: '15%',
          width: '80px',
          height: '80px',
          animationDelay: '2s'
        }}
      />
      <div 
        className="geometric-shape"
        style={{
          bottom: '20%',
          left: '20%',
          width: '60px',
          height: '60px',
          animationDelay: '4s'
        }}
      />

      {/* Sparkle Effects */}
      {[...Array(20)].map((_, i) => (
        <div
          key={`sparkle-${i}`}
          className="sparkle"
          style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 4}s`
          }}
        />
      ))}

      {/* Main Content */}
      <div className="coming-soon-container">
        <h1 className="main-title">
          🚀 Coming Soon
        </h1>
        
        <h2 className="subtitle">
          German Practice Platform
        </h2>
        
        <div className="message">
          <p style={{ marginBottom: '20px' }}>
            We're crafting something amazing for your German learning journey! 
          </p>
          <p style={{ marginBottom: '20px' }}>
            Our interactive practice platform will feature:
          </p>
          
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '15px', 
            margin: '20px 0' 
          }}>
            <div style={{ 
              padding: '10px', 
              background: 'rgba(255, 255, 255, 0.1)', 
              borderRadius: '10px',
              fontSize: '0.9rem'
            }}>
              📚 Interactive Lessons
            </div>
            <div style={{ 
              padding: '10px', 
              background: 'rgba(255, 255, 255, 0.1)', 
              borderRadius: '10px',
              fontSize: '0.9rem'
            }}>
              🎯 Practice Exercises
            </div>
            <div style={{ 
              padding: '10px', 
              background: 'rgba(255, 255, 255, 0.1)', 
              borderRadius: '10px',
              fontSize: '0.9rem'
            }}>
              🏆 Progress Tracking
            </div>
            <div style={{ 
              padding: '10px', 
              background: 'rgba(255, 255, 255, 0.1)', 
              borderRadius: '10px',
              fontSize: '0.9rem'
            }}>
              🎮 Gamified Learning
            </div>
          </div>
          
          <p style={{ 
            marginTop: '30px', 
            fontWeight: 'bold',
            fontSize: '1.2rem',
            color: '#fff'
          }}>
            Thank you for your patience! ❤️
          </p>
        </div>
      </div>

      {/* Additional Floating Elements */}
      <div style={{
        position: 'absolute',
        top: '20%',
        right: '10%',
        fontSize: '4rem',
        animation: 'float 6s ease-in-out infinite',
        animationDelay: '1s'
      }}>
        📖
      </div>
      
      <div style={{
        position: 'absolute',
        bottom: '30%',
        left: '5%',
        fontSize: '3rem',
        animation: 'float 8s ease-in-out infinite',
        animationDelay: '3s'
      }}>
        🇩🇪
      </div>
      
      <div style={{
        position: 'absolute',
        top: '60%',
        right: '20%',
        fontSize: '2.5rem',
        animation: 'float 7s ease-in-out infinite',
        animationDelay: '2s'
      }}>
        ⭐
      </div>
    </div>
  );
};

export default StartPractice;
